"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _css = require("@emotion/css");
var _react = require("react");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles(layout) {
  var isDragOver = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    themeColors = _useContext.themeColors,
    basicFontSize = _useContext.basicFontSize,
    direction = _useContext.direction;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var ccUploaderStyle = (0, _react.useMemo)(function () {
    var uploaderHiddenInput = function uploaderHiddenInput() {
      if (layout === 'button') {
        return {};
      }
      return {
        width: '100%',
        height: '100%',
        left: 0,
        top: 0
      };
    };
    var deviceProps = function deviceProps() {
      var height = isMobileView ? '100%' : 'auto';
      return {
        height: height
      };
    };
    var drop = (0, _css.css)(_objectSpread({
      position: 'relative'
    }, deviceProps()));
    var dropZone = (0, _css.css)(_objectSpread({
      fontFamily: fontFamily,
      borderRadius: pxToRem(10),
      border: "2px dashed ".concat(themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText),
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text,
      fontSize: basicFontSize,
      backgroundColor: isDragOver ? themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.main : themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.light,
      textAlign: 'center'
    }, deviceProps()));
    var hiddenInput = (0, _css.css)(_objectSpread({
      position: 'absolute',
      opacity: 0
    }, uploaderHiddenInput()));
    var title = (0, _css.css)({
      fontSize: pxToRem(26),
      fontWeight: 700,
      marginBlock: pxToRem(20),
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText
    });
    var or = (0, _css.css)({
      marginBottom: pxToRem(20),
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText
    });
    var limits = (0, _css.css)({
      margin: "".concat(pxToRem(60), " ").concat(pxToRem(20), " ").concat(pxToRem(20)),
      display: 'flex',
      justifyContent: 'center',
      direction: direction,
      span: {
        display: 'inline-block',
        marginInlineEnd: pxToRem(2)
      }
    });
    var limitsSecond = (0, _css.css)({
      marginInlineStart: pxToRem(10)
    });
    var error = (0, _css.css)({
      fontSize: pxToRem(12),
      margin: pxToRem(20)
    });
    return {
      drop: drop,
      dropZone: dropZone,
      hiddenInput: hiddenInput,
      title: title,
      or: or,
      limits: limits,
      limitsSecond: limitsSecond,
      error: error
    };
  }, [basicFontSize, direction, fontFamily, isDragOver, isMobileView, layout, pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.light, themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.main, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.subText, themeColors === null || themeColors === void 0 ? void 0 : themeColors.general.text]);
  return {
    'cc-Uploader__drop': ccUploaderStyle.drop,
    'cc-Uploader__drop-zone': ccUploaderStyle.dropZone,
    'cc-Uploader__hidden-input': ccUploaderStyle.hiddenInput,
    'cc-Uploader__title': ccUploaderStyle.title,
    'cc-Uploader__or': ccUploaderStyle.or,
    'cc-Uploader__limits': ccUploaderStyle.limits,
    'cc-Uploader__limits__second': ccUploaderStyle.limitsSecond,
    'cc-Uploader__error': ccUploaderStyle.error
  };
};
exports.useStyles = useStyles;